export default {
  // 是否有商旅权限
  hasTravelAuth: false,
}
